var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeClosedWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4455 11.5457C11.2582 11.7606 11.0324 11.933 10.7815 12.0525C10.5306 12.1721 10.2597 12.2364 9.98506 12.2416C9.71042 12.2468 9.43761 12.1927 9.18292 12.0827C8.92822 11.9727 8.69686 11.8089 8.50262 11.6012C8.30839 11.3935 8.15527 11.1461 8.05239 10.8737C7.94952 10.6013 7.899 10.3095 7.90384 10.0158C7.90869 9.72211 7.9688 9.43244 8.0806 9.16411C8.19239 8.89578 8.35358 8.65428 8.55455 8.45402M14.05 14.3311C12.8845 15.2812 11.4653 15.8075 10 15.8332C5.22727 15.8332 2.5 9.99985 2.5 9.99985C3.34811 8.30956 4.52441 6.83279 5.95 5.6686L14.05 14.3311ZM8.56818 4.34152C9.0375 4.22404 9.518 4.16531 10 4.16652C14.7727 4.16652 17.5 9.99985 17.5 9.99985C17.0861 10.8279 16.5925 11.6075 16.0273 12.3259L8.56818 4.34152Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.96875 2.5L17.5 17.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClosedWhite);
export default __webpack_public_path__ + "static/media/eye_closed_white.cae3035071326913e4c1ac596cf0fa98.svg";
export { ForwardRef as ReactComponent };